import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import './style.scss';
import useBluetooth from '../../hooks/useBluetooth'
import { notification } from 'antd';
import { AudioOutlined, PauseCircleOutlined } from '@ant-design/icons';
import RecorderVolumeIndicator from '../../components/volumeIndicator/RecorderVolumeIndicator'
// import { speech2Recognition } from '../../utils';
import { sendTextInChunks } from '../../utils';
import { useRealTimeAudioRecording } from './useRealTimeAudioRecording';
import { useAudioRecording } from './useAudioRecording';

let global_uid
const CxSpeech2Text = () => {
    const [recognitionResult, setRecognitionResult] = useState(null);
    const [realTimePowerLevel, setRealTimePowerLevel] = useState(0);
    const [isRecognizing, setIsRecognizing] = useState(false); // 添加识别loading状态
    const lan = useRef(null)
    const during = useRef(null)
    const msgId = useRef(null)
    const timer = useRef(null);
    const bluetooth = useSelector(state => state.speaker.bluetooth);
    const { sendMessage, setupNotifications, stopNotifications } = useBluetooth();
    const [tipsInfo, setTipsInfo] = useState(null)
    const isAvailable = useRef(true)
    const [resp, setResp] = useState(null)
    const isTooEarly = (next_use_time) => {
        const target = new Date(next_use_time);      // 转换为 Date 对象
        const now = new Date();                    // 当前时间

        if (now < target) {
            return true
        } else {
            return false
        }
    }
    // // 文本分组发送函数
    // const sendTextInChunks = useCallback((text, messageId) => {
    //     const maxChunkSize = 100; // 每组最大120个字符
    //     const chunks = []
    //     // 将文本按120个字符分组
    //     for (let i = 0; i < text.length; i += maxChunkSize) {
    //         chunks.push(text.slice(i, i + maxChunkSize))
    //     }
    //     chunks.forEach((content, index) => {
    //         setTimeout(() => {
    //             sendMessage({
    //                 [messageId]: {
    //                     content,
    //                     index: index + 1,
    //                     total: chunks.length
    //                 }
    //             });
    //         }, index * 1000) // 每个消息间隔1秒发送
    //     })
    // }, [sendMessage]);
    
    // 设置浮窗部分
    const setMsg = useCallback((response_template, msg) => {
        let type = response_template.type
        let message = msg
        let description = response_template.message
        const typeArray = ['success', 'info', 'warning', 'error']
        if (type && !typeArray.includes(type.toLowerCase())) {
            type = 'info'
        }
        notification[type]({
            message,
            description
        })
    }, [])

      // 设置提示文案部分 - 暂时注释掉
    const setTips = (response_template) => {
        setResp(response_template)
        const { can_use, any_minutes, any_minutes_limit, remain_nums, next_use_time } = response_template
        setTipsInfo({
            can_use,
            tips: `当前账户每 ${any_minutes} 分钟可实验 ${any_minutes_limit} 次。今日总共还可实验 ${remain_nums} 次。`,
            next_use: `下一次扫描需等到 ${next_use_time}`
        })
    }

    // 1. 完整录音识别
    const {
        isRecording,
        powerLevel: recordingPowerLevel,
        checkMicrophonePermission,
        startCompleteRecognition
    } = useAudioRecording({
        onRecordingStart: () => {
            console.log('完整录音开始');
        },
        onRecognitionStart: () => {
            console.log('开始语音识别');
            setIsRecognizing(true);
        },
        onThen(res) {
            console.log('语音识别结果:', res);
            setIsRecognizing(false); // 识别完成，关闭loading
            setTips(res.response_template)
            if (res.success) {
                const text = res.data.map(item => item).join(' ');
                setRecognitionResult(text);
                // 使用分组发送
                sendTextInChunks(text, (content, index, total) => {
                    sendMessage({
                        [msgId.current]: {
                            content,
                            index,
                            total
                        }
                    });
                });
            } else {
                sendMessage({ [global_uid]: `${global_uid}_error` })
                setMsg(res.response_template, res.message)
            }
        },
        onCatch(error) {
            setIsRecognizing(false); // 识别出错，关闭loading
            // const { message: msg, response_template } = error.data
            // setMsg(response_template, msg)
            if (error.data) {
                const { message: msg, response_template } = error.data
                setMsg(response_template, msg)
                setTips(response_template)
            }
            sendMessage({ [global_uid]: `${global_uid}_error` })
        },
        onVolumeChange: (volume) => {
            // 这里可以处理录音时的音量变化
        },
        onError: (error) => {
            console.error('录音错误:', error);
            setIsRecognizing(false); // 录音出错，关闭loading
            sendMessage({ [global_uid]: `${global_uid}_error` })
            notification.error({
                message: '录音失败',
                description: error.message || '录音过程中出现错误'
            });
        }
    });

    // 2. 实时识别
    const {
        isListening,
        startRealTimeRecognition,
        stopRecognition,
        clearResult
    } = useRealTimeAudioRecording({
        onResult: (result) => {
            console.log('识别结果:', result);
            sendMessage({
                [msgId.current]: {
                    content: result
                }
            })
            setRecognitionResult(result);
        },
        onThen(res) {
            // 后端接口返回内容
            setTips(res.response_template)
            if (!res.success) {
                sendMessage({ [global_uid]: `${global_uid}_error` })
            }
        },
        onError: (error) => {
            console.error('识别错误:', error);
            sendMessage({ [global_uid]: `${global_uid}_error` });
        },
        onCatch(error) {
            if (error.data) {
                const { message: msg, response_template } = error.data
                setMsg(response_template, msg)
                setTips(response_template)
            }
            sendMessage({ [global_uid]: `${global_uid}_error` })
        },
        onVolumeChange: (volumeLevel) => {
            // 实时更新音量级别
            setRealTimePowerLevel(volumeLevel);
        },
    });
    const [params, setParams] = useState(null)
    // 在组件挂载时启动扫描，卸载时停止扫描
    const onMessageReceived = useCallback(async (result) => {
        const lanMap = {
            1537: '中文普通话',
            15372: '中文普通话',
            17372: '英语',
            1737: '英语',
            1936: '中文普通话',
            1637: '粤语',
            1837: '四川话'
        }
        const data = result.find((item) => item.includes('plugin'));
        if (!data) {
            return;
        }
        const slice = data.split('//');
        console.log('data->', data)
        console.log(`命令：${slice[2]}, uid：${slice[3]}`)
        const uid = global_uid = slice[3];
        if (slice.includes('is_connect_ailab')) {
            sendMessage({ [uid]: `${uid}_success` })
        }
        
        // 指令
        const command = slice[2];
        console.log(command, 'command')
        msgId.current = uid
        // 完整识别
        if (command === 'complete_recognition') {
            if (!isAvailable.current || (resp && isTooEarly(resp.next_use_time))) {
                sendMessage({ [uid]: `${uid}_error` })
                return
            }
            let args = slice[4] // 语音类型
            if (args) {
                args = args.split(',')
                lan.current = args && args[0]
                let _during = args && args[1]
                during.current = _during
            }
            setParams({
                model: '完整识别',
                lan: lanMap[lan.current],
                during: args && args[1] + ' 秒'
            })
            // 使用新的 hook 开始录音
            startCompleteRecognition({during: during.current, lan: lan.current});
            console.log('complete_recognition - 开始录音，将在', during.current || 5, '秒后自动停止')
        // 实时识别
        } else if (command === 'realtime_recognition') {
            if (!isAvailable.current || (resp && isTooEarly(resp.next_use_time))) {
                sendMessage({ [uid]: `${uid}_error` })
                return
            }
            console.log(slice, 'sliceslice')
            let args = slice[4] // 语音类型
            if (args) {
                args = args.split(',')
                lan.current = args && args[0]
                during.current = args && args[1]
            }
            setParams({
                model: '实时识别',
                lan: lanMap[lan.current],
                during: during.current + ' 秒'
            })
            console.log(lan.current, during.current, 'lan_during2222')
            startRealTimeRecognition({during: during.current, lan: lan.current})
        // 停止实时识别
        } else if (command === 'stop_realtime') {
            console.log('stop_realtime - 停止实时识别')
            stopRecognition();
            
            // 发送停止确认
            sendMessage({
                [uid]: `${uid}_success`
            });
        // 清空识别结果
        } else if (command === 'reset') {
            console.log('reset - 清空识别结果')
            
            // 清空状态
            setRealTimePowerLevel(0);
            setRecognitionResult(null);
            
            // 发送清空确认
            sendMessage({ 
                [uid]: `${uid}_success`
            });
            
            notification.info({
                message: '识别结果已清空',
                description: '所有录音和识别数据已清除'
            });
        }
       
    }, [sendMessage, startRealTimeRecognition, startCompleteRecognition, stopRecognition, resp])

    // 初始化麦克风权限检查
    useEffect(() => {
        const checkPermission = async () => {
            const result = await checkMicrophonePermission();
            console.log(result, 'result')
            if (!result.success) {
                // 显示麦克风错误提示，不会自动关闭
                notification.error({
                    message: result.errorMessage,
                    description: result.errorDescription,
                    duration: 0, // 不自动关闭，需要用户手动关闭
                    placement: 'topRight'
                });
                isAvailable.current = false
            } else {
                isAvailable.current = true
            }
        };
        checkPermission();
    }, [checkMicrophonePermission]);
    
    

    // 在组件加载时检查蓝牙连接状态并设置监听
    useEffect(() => {
        setupNotifications(onMessageReceived)
        const currentTimer = timer.current;
        return () => {
            if (currentTimer) {
                clearInterval(currentTimer);
            }
            stopNotifications(onMessageReceived)
        };
    }, [bluetooth, setupNotifications, stopNotifications, onMessageReceived]);

    // 组件卸载时清理录音资源
    useEffect(() => {
        return () => {
            // 清理工作由各自的 hook 处理
        };
    }, []);


    return (
        <div className='cxspeech2Text plug-in'>
            <div className='plug-in-name'>语音识别 2.0</div>
            <div className='plug-in-content'>
                <div className='desc-content'>
                    <div className='desc-content describe'>
                        <div className="cxspeech2Text__bold">
                            语音识别的原理就像让计算机学会「听懂人说话」：
                        </div>
                        <div className="cxspeech2Text__block">
                            首先，系统会把接收到的声音信号转成数字形式，并分解成一个个细小的声音单元，就像把一段话切成音的“积木块”。
                        </div>
                        <div className="cxspeech2Text__block">
                            接着，它会利用语言学知识和统计规律，判断这些声音单元对应的是哪些音素和词语，并结合上下文去消除歧义，就像人在对话中通过前后文推断别人的意思。
                        </div>
                        <div className="cxspeech2Text__block">
                            最后，识别结果会被组装成完整的文字输出，有的系统还会进一步分析句法和语义，让“听懂”的内容可以直接被搜索、翻译或执行成具体操作。
                        </div>
                    </div>
                    <div className="cxspeech2Text__block">
                        <div>
                            本扩展可在互联创作平台使用，或连接主控硬件后结合硬件编程平台使用。
                        </div>
                        <div className="cxspeech2Text__flex">
                            <div className="cxspeech2Text__video">
                                <span className="cxspeech2Text__title">当前参数</span>
                                <div className="cxspeech2Text__items">
                                    <div><span className="cxspeech2Text__key">识别类型：</span>{params && params.lan || '-'}</div>
                                    <div><span className="cxspeech2Text__key">模型：</span>{params && params.model || '-'}</div>
                                    <div><span className="cxspeech2Text__key">时长：</span>{params && params.during || '-'}</div>
                                </div>
                                 
                                 {/* 录音状态指示器 */}
                                <div
                                    className='cxspeech2Text__recorder'>
                                    {/* 录音状态图标 */}
                                    <div
                                        className='cxspeech2Text__label'
                                        style={{ 
                                            color: '#666'
                                        }}>
                                         {(isRecording || isListening) ? (
                                             <>
                                                <div
                                                    className='cxspeech2Text__dot'
                                                    style={{
                                                        backgroundColor: '#52C41A',
                                                    }} />
                                                <span>
                                                    {isRecording ? '录音中' : '识别中'}
                                                </span>
                                             </>
                                         ) : (
                                             <>
                                                <div
                                                    className='cxspeech2Text__dot'
                                                    style={{
                                                        backgroundColor: '#d9d9d9',
                                                    }} />
                                                <span>待机中</span>
                                             </>
                                         )}
                                     </div>
                                     
                                    {/* 音量指示器 */}
                                    <div style={{ flex: 1 }}>
                                        <RecorderVolumeIndicator
                                            powerLevel={isListening ? realTimePowerLevel : recordingPowerLevel}
                                            isRecording={isRecording || isListening}
                                            barCount={24}
                                            width={428}
                                            height={30}
                                            sensitivity={1.5}
                                            smoothing={0.4}
                                         />
                                    </div>
                                </div>
                            </div>
                            <div className="cxspeech2Text__video">
                                <span className="cxspeech2Text__title">最近一次识别的语音</span>
                                <div className="cxspeech2Text__content">
                                    {isRecognizing ? (
                                        <div className="cxspeech2Text__loading">
                                            <div className="cxspeech2Text__loading-spinner"></div>
                                            <div className="cxspeech2Text__loading-text">正在识别中...</div>
                                        </div>
                                    ) : recognitionResult ? (
                                        <div className="cxspeech2Text__text">
                                            {recognitionResult}
                                        </div>
                                    ) : (
                                        <div>
                                            <img className="cxspeech2Text__img" src="/image/icon-voice.png" alt="声音"/>
                                            <div className="cxspeech2Text__no-result">暂未进行过识别</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {
                                tipsInfo !== null && 
                                    <>
                                        <div className="cxspeech2Text__tips">
                                            {tipsInfo?.tips}
                                        </div>
                                        {tipsInfo.can_use === false && <div className='cxspeech2Text__tips cxspeech2Text__tips--error'>{tipsInfo?.next_use}</div>}
                                    </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CxSpeech2Text;
